import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import inputFields from "./inputFields";
import { Link, useNavigate } from "react-router-dom";
import {
  ChemistEdit,
  CountryCode,
  DoctorEdit,
  DoctorDel,
  getChemistList,
} from "store/actions";
import EditDoctor from "components/Modals/EditDoctorModal";
import countryList from "react-select-country-list";
import FormikForm from "components/shared/FormikForm";
import { CHEMISTDATA } from "common/viewContent";
import EditChemist from "components/Modals/EditChemist";
import ConfirmModal from "components/Modals/ConfirmModal";
const InputFieldsForSearch = [
  {
    name: "search_text",
    type: "text",
    placeholder: "Search using name,email...",
  },
];
const initialValuesForFilter = {
  search_text: "",
};
const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const options = countryList().getData();
  const [editData, setEditData] = useState();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const { CHEMIST, loading, totalCount } = useSelector(
    (state) => state.chemistData
  );
  const [chemist, setChemist] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [editModalShow, setEditModalShow] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [search, setSearch] = useState("");
  const [countryListData, setCountryListData] = useState();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    country: "",
    state: "",
    email: "",
    phone_no: "",
    country_code: "",
    city: "",
    license_no:"",
  });

  const onCliclNavigate = (id) => {
    navigate(`/admin/feedback/${id}`);
  };
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      user_role: "3",
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setChemist(res);
        }
      };
      dispatch(getChemistList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const fetchCountryData = async () => {
    let data = {};
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setCountryListData(res.data);
        }
      };
      dispatch(
        CountryCode({
          data: data,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    const CountryList = options?.map((item) => {
      return { value: item?.label, label: item?.label };
    });
    inputFields.find((field) => field.type === "select").options =
      CountryList || [];
    const CountryCodeArray = countryListData?.map((obj) => {
      return { value: obj.calling_code, label: obj.calling_code };
    });
    inputFields.find((field) => field.type === "dynamic_select").options =
      CountryCodeArray || [];
  }, [countryListData, options]);
  useEffect(() => {
    fetchData(filter);
    fetchCountryData();
    setcolumns(
      Columns({
        onCliclNavigate,
        handleViewUser,
        handleEdithandler,
        handleUserStatus,
        deleteHandler,
        currentPage: filter?.pageNo,
        pageSize,
      })
    );
  }, [filter]);
  const handleEdithandler = (info) => {
    setFormData({ ...formData, ...info });
    setEditData(info);
    setEditModalShow(true);
  };
  const handleEditSub = (info) => {
    try {
      let data = {
        user_id: info.id,
        first_name: info.first_name,
        middle_name: info.middle_name,
        last_name: info.last_name,
        country: info.country,
        state: info.state,
        email: info.email,
        phone_no: info.phone_no,
        country_code: info?.country_code,
        city: info.city,
        license_no: info.license_no,
      };
      const callback = (err, res) => {
        if (err) {
          toast.error(err.toString());
        } else {
          setEditModalShow(false);
          fetchData(filter);
          toast.success("User updated successfully!");
        }
      };
      dispatch(
        ChemistEdit({
          data: data,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleUserStatus = (row, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData(filter);
          toast.success("Status Changed");
        }
      };
      dispatch(
        ChemistEdit({
          data: { user_id: row?.id, status: status },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const deleteHandler = (id) => {
    setConfirmModal(true);
    setDeleteId(id);
  };
  const handleDeleteConfirm = (event) => {
    event.preventDefault();
    const callback = (err, res) => {
      if (err) {
        toast.error(err);
      } else {
        toast.success(res.message);
        fetchData(filter);
      }
    };
    dispatch(
      DoctorDel({
        data: { user_id: deleteId, is_deleted: "1" },
        callback,
      })
    );
    setConfirmModal(false);
    setDeleteId(null);
  };

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };

  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };

  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };
  const handleViewUser = (row) => {
    navigate(`${row.id}`, { state: { row } });
  };



  return (
    <>
      {confirmModal && (
        <ConfirmModal
          show={confirmModal}
          handleClose={() => setConfirmModal(false)}
          title={"Confirmation"}
          content={"Are you sure you want to delete User"}
          handleConfirm={handleDeleteConfirm}
          loading={""}
        />
      )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {editModalShow && (
        <EditChemist
          show={editModalShow}
          handleClose={() => {
            setEditModalShow(false);
          }}
          title={"Edit Doctor"}
          content={""}
          handleConfirm={handleEditSub}
          loading={loading}
          initialValues={formData}
          editData={editData}
        />
      )}
      <Helmet title={CHEMISTDATA.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{CHEMISTDATA.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{CHEMISTDATA.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{CHEMISTDATA.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* <div className="col-12 px-0">
                <div className="card-header px-0 ">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div> */}
            </div>
          </div>
          {!loading && CHEMIST?.users?.length > 0 && (
            <Table
              data={CHEMIST?.users}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handleTableChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {CHEMIST?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Chemist Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
